export const recentEntityTileDimension = {
  height: 230,
  width: 282,
};
